/**
 * @generated SignedSource<<c1f87f548449d58020650fca54dbf8aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OwnedProjectRow_project$data = {
  readonly id: string;
  readonly name: string | null;
  readonly companyProjectId: number | null;
  readonly customProjectId: string | null;
  readonly projectColor: string | null;
  readonly " $fragmentType": "OwnedProjectRow_project";
};
export type OwnedProjectRow_project$key = {
  readonly " $data"?: OwnedProjectRow_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"OwnedProjectRow_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OwnedProjectRow_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "706813f91e8e731d0e76690497fd848c";

export default node;
